"use strict";

module.exports = global.fetch;
//# sourceMappingURL=fetch.js.map